import React from 'react';
import { LayoutColumns } from '@saleshandy/icons';
import { accessibleOnClick } from '../../../../utils/accessible-on-click';

interface ColumnVisibilityControlProps {
  onClick: () => void;
  isLoading: boolean;
}

const ColumnVisibilityControl: React.FC<ColumnVisibilityControlProps> = ({
  onClick,
}) => (
  <div className="layout-columns-button" {...accessibleOnClick(onClick)}>
    <LayoutColumns />
  </div>
);

export default ColumnVisibilityControl;

